// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__1lUq_","content":"RecentSearches_content__VMEnM"};